import React from "react";
import clsx from "clsx";
import {makeStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

import InputFormElement from "../../../../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import {mergeClasses} from "../../../../../../../../utils/utils";

const useDefaultStyles = makeStyles(() => ({
  inputRoot: {
    height: 30,
    margin: 0,
    fontSize: 14,
    width: '100%',
    '&.Mui-error': {
      borderColor: '#f44336',
    },
    '&.text-red': {
      color: '#f44336 !important',
    },
    '&.text-green': {
      color: '#60ce7a !important',
    },
  },
  priceContainer: {
    textAlign: 'right',
    fontSize: 12,
    whiteSpace: 'nowrap'
  },
}));

/**
 * A numeric input field for switch transaction columns (quantity, euro, percentage).
 *
 * @param {*} value - The current display value
 * @param {function} onChange - (value) => void
 * @param {string|null} error - Error message to display
 * @param {React.Component} inputComponent - Number format component (QtyNumberFormat | CurrencyNumberFormat | PercentageNumberFormat)
 * @param {object} [inputProps] - Props passed to the number format (e.g. {suffix: '', allowNegative: true, decimalScale: 3})
 * @param {boolean} [disabled=false] - Disabled state
 * @param {string} [currentValueLabel] - If provided, shows "Aktuell: {label}" below the input
 * @param {string} [inputRootClassName] - Additional className to append to inputRoot
 * @param {object} [classes] - Style overrides to merge with defaults
 */
const SwitchQuantityField = ({
  value,
  onChange,
  error,
  inputComponent,
  inputProps,
  disabled = false,
  currentValueLabel,
  inputRootClassName,
  classes: classesProp,
}) => {
  const defaultClasses = useDefaultStyles();
  const classes = mergeClasses(defaultClasses, classesProp);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <InputFormElement
          disabled={disabled}
          error={error}
          value={value}
          onChange={onChange}
          inputComponent={inputComponent}
          inputProps={{inputProps: inputProps || {}}}
          type="text"
          custom_classes={{
            ...classes,
            inputRoot: clsx(classes.inputRoot, inputRootClassName),
          }}
        />
      </Grid>
      {currentValueLabel && (
        <Grid item xs={12} className={classes.priceContainer}>
          <b>Aktuell:</b> {currentValueLabel}
        </Grid>
      )}
    </Grid>
  );
};

export default SwitchQuantityField;
